/** @file UTF-8 decoding of bytes, hand-written (the package's lib has no TextDecoder). */

/** Continuation bytes after a lead byte, and the lead byte's payload mask. */
function leadOf(b: number): [number, number] {
  if (b < 0x80) return [0, 0x7f];
  if (b >= 0xf0 && b < 0xf8) return [3, 0x07];
  if (b >= 0xe0) return [2, 0x0f];
  if (b >= 0xc0) return [1, 0x1f];
  return [-1, 0];
}

/** The code point at `i` and the bytes it took; a malformed sequence is U+FFFD over one byte. */
function pointAt(bytes: Uint8Array, i: number): [number, number] {
  const [extra, mask] = leadOf(bytes[i] ?? 0);
  if (extra < 0 || i + extra >= bytes.length) return [0xfffd, 1];
  let c = (bytes[i] ?? 0) & mask;
  for (let k = 1; k <= extra; k += 1) {
    const b = bytes[i + k] ?? 0;
    if ((b & 0xc0) !== 0x80) return [0xfffd, 1];
    c = (c << 6) | (b & 0x3f);
  }
  return [c, extra + 1];
}

/** The string `bytes` encode; malformed sequences decode as U+FFFD. */
export function fromUtf8(bytes: Uint8Array): string {
  const points: number[] = [];
  for (let i = 0; i < bytes.length;) {
    const [c, n] = pointAt(bytes, i);
    points.push(c > 0x10ffff ? 0xfffd : c);
    i += n;
  }
  let out = '';
  for (let i = 0; i < points.length; i += 4096) out += String.fromCodePoint(...points.slice(i, i + 4096));
  return out;
}
